import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProcessingGuideSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type ProcessingGuideSubscription = { __typename?: 'subscription_root', guides_by_pk?: { __typename?: 'guides', id: any, updated_at: any, title?: string | null, status: string, description?: string | null, video_url?: string | null, created_by_user_id?: string | null, organization_id?: any | null, guide_steps: Array<{ __typename?: 'guide_steps', id: any, title: string, body?: string | null, image_url?: string | null, video_url?: string | null }>, product_guides: Array<{ __typename?: 'product_guides', id: any, product?: { __typename?: 'products', id: any, photo_link?: string | null, installed_products: Array<{ __typename?: 'installed_products', id: any, property_id: any, photo_link?: string | null }>, product_attachments: Array<{ __typename?: 'product_attachments', id: any, photo_link?: string | null }> } | null }> } | null };


export const ProcessingGuideDocument = gql`
    subscription processingGuide($id: uuid!) {
  guides_by_pk(id: $id) {
    id
    updated_at
    title
    status
    description
    video_url
    guide_steps {
      id
      title
      body
      image_url
      video_url
    }
    product_guides {
      id
      product {
        id
        photo_link
        installed_products(distinct_on: property_id) {
          id
          property_id
          photo_link
        }
        product_attachments {
          id
          photo_link
        }
      }
    }
    created_by_user_id
    organization_id
  }
}
    `;

/**
 * __useProcessingGuideSubscription__
 *
 * To run a query within a React component, call `useProcessingGuideSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProcessingGuideSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessingGuideSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProcessingGuideSubscription(baseOptions: Apollo.SubscriptionHookOptions<ProcessingGuideSubscription, ProcessingGuideSubscriptionVariables> & ({ variables: ProcessingGuideSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ProcessingGuideSubscription, ProcessingGuideSubscriptionVariables>(ProcessingGuideDocument, options);
      }
export type ProcessingGuideSubscriptionHookResult = ReturnType<typeof useProcessingGuideSubscription>;
export type ProcessingGuideSubscriptionResult = Apollo.SubscriptionResult<ProcessingGuideSubscription>;